module.exports = __webpack_public_path__ + "img/icon_key.e9d32347.png";